import { api } from "assets/scripts/utilities/api-clients";
import { omitKeys } from "src/assets/scripts/utilities/helpers";

const prepareDispatch = (dispatch) => {
  dispatch = omitKeys(dispatch, ["invoice"]);

  return dispatch;
};
export const get = async (id) => {
  const response = await api.get(`/kam/shippings/${id}`);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("/kam/shippings", options);

  return response;
};

export const post = async (user) => {
  const response = await api.post("/kam/shippings", prepareDispatch(user));

  return response;
};

export const put = async (user) => {
  const response = await api.put("/kam/shippings", user);

  return response;
};
